import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { setCondition } from "../../actions/cache";
import { search as searchGalleries } from "../../actions/gallery";
import SectionFilterForm from "../../components/forms/SectionFilterForm";
import Meta from "../../components/layout/Meta";
import GalleriesList from "../../components/lists/Galleries";
import { Button } from "../../components/util/Clickable";
import { getPureMessage, IntlText } from "../../components/util/Text";

class GalleriesScreen extends PureComponent {
  state = {
    galleries: null,
    section_id: null,
    meta: {
      current_page: 0,
      last_page: null,
    },
    loading: false,
  };

  componentWillMount = () => {
    if (this.props.condition[window.location.href]) {
      this.setState(this.props.condition[window.location.href]);
    } else {
      this.readMore(true);
    }
  };

  readMore = (refresh = false) => {
    if (!refresh) {
      this.setState({ loading: true });
    }
    this.props.actions
      .searchGalleries({
        fair_id: this.props.fair.id,
        section_id: this.state.section_id,
        page: this.state.meta.current_page + 1,
        pagesize: 24,
        excludes: this.state.galleries
          ? this.state.galleries.map((a) => a.id).join(",")
          : "0",
      })
      .then(({ value, action }) => {
        if (value.status < 300) {
          this.setState({
            galleries:
              this.state.galleries && !refresh
                ? this.state.galleries.concat(value.data)
                : value.data,
            meta: value.response.data.meta,
            loading: false,
          });
          this.props.actions.setCondition(this.state);
        }
      })
      .catch((error) => console.log(error));
  };

  onSearch = (values) => {
    this.setState(
      {
        section_id: values.section_id,
        galleries: null,
        meta: {
          current_page: 0,
        },
      },
      () => {
        this.readMore(true);
      },
    );
  };

  render = () => {
    return (
      <div>
        <Meta
          title={getPureMessage("fairs.galleries.meta") + this.props.fair.title}
          description={this.props.fair.description}
          image={this.props.fair.thumnail_url}
        />
        <h1 className="uk-heading-mark uk-margin-remove uk-h2">
          <IntlText
            id="fairs.galleries.title"
            values={{ title: this.props.fair.title }}
          />
        </h1>
        <div className="uk-margin-medium">
          <SectionFilterForm
            initialValues={{ section_id: this.state.section_id }}
            onChange={this.onSearch}
            sections={this.props.fair.sections}
          />
        </div>
        <div className="uk-margin-medium">
          <GalleriesList galleries={this.state.galleries} />
        </div>
        {this.state.meta.last_page &&
          this.state.meta.last_page > this.state.meta.current_page && (
            <div className="uk-margin-medium uk-text-center">
              <Button
                className="uk-button uk-button-default"
                onClick={() => this.readMore(false)}
                loading={this.state.loading ? 1 : 0}
                ga={{
                  category: "button",
                  action: "fair_galleries",
                  label: "more",
                }}
              >
                <IntlText id="forms.more" />
              </Button>
            </div>
          )}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    condition: state.condition,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      searchGalleries: (...param) => dispatch(searchGalleries(...param)),
      setCondition: (...param) => dispatch(setCondition(...param)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GalleriesScreen),
);
